<template>
    <IconSvg viewBox="0 0 24 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.175 34.8387L17.0537 36.96L4.79021 24.6966C4.39968 24.306 4.39968 23.6729 4.79021 23.2823L17.0537 11.0189L19.175 13.1402L8.32574 23.9895L19.175 34.8387Z"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
